import { colors } from './colors'

export const globals = {
  textColor: colors.gray3,
  margin: '5px'
}
